export const PermissionProducts = {
    PUT: "mgr-products-**-PUT",
    POST: "mgr-products-POST",
    DELETE: "mgr-products-**-DELETE",
    GET: "mgr-products-search-**-GET",
    GET_UUID: "mgr-products-**-GET"
};